import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getLocal } from '../../utils/api';

import Header from '../header/Header';

import './Profile.css';

function Profile({ handleFeedback, handlePath, handleStartOver }) {
  const navigate = useNavigate();

  const [directions, setDirections] = useState(null);
  const [financial, setFinancial] = useState(null);
  const [future, setFuture] = useState(null);
  const [geography, setGeography] = useState(null);
  const [pills, setPills] = useState(null);
  const [profile, ] = useState(getLocal('profile'));
  const [strengths, setStrengths] = useState(null);
  const [userDescription, setUserDescription] = useState(null);
  const [userName, setUserName] = useState(null);
  const [values, setValues] = useState(null);

  const handleDetails = useCallback(() => {
    navigate('/profile/details');
  }, [navigate]);

  useEffect(() => {
    if (profile?.meta_data) {
      const name = profile.meta_data.find(item => item.param === 'name');

      if (name?.value) {
        setUserName(name.value);
      } else {
        const firstName = profile.meta_data.find(item => item.param === 'first_name');
        setUserName(firstName?.value);
      }

      const location = profile.meta_data.find(item => item.param === 'location');
      setUserDescription(location?.value);

      const pillParams = ['school', 'grade'];
      let pills = [];
      
      pillParams.forEach(param => {
        const item = profile.meta_data.find(item => item.param === param);

        if (item?.value) {
          pills.push(item.value);
        }
      });

      setPills(pills);

      let direction = profile.meta_data.find(item => item.param === 'direction');

      if (direction?.value) {
        direction = (Array.isArray(direction.value) ? direction.value : direction.value.split(', '));
      } else {
        direction = [];
      }

      setDirections(direction);

      const future = profile.meta_data.find(item => item.param === 'future' && item.value);

      if (future) {
        setFuture(future.value);
      }

      let values = profile.meta_data.find(item => item.param === 'values');

      if (values?.value) {
        values = (Array.isArray(values.value) ? values.value : values.value.split(', '));
      } else {
        values = [];
      }

      setValues(values);

      let strengths = profile.meta_data.find(item => item.param === 'strengths');

      if (strengths?.value) {
        strengths = (Array.isArray(strengths.value) ? strengths.value : strengths.value.split(', '));
      } else {
        strengths = [];
      }

      setStrengths(strengths);

      let geography = profile.meta_data.find(item => item.param === 'geography');

      if (geography?.value) {
        geography = (Array.isArray(geography.value) ? geography.value : geography.value.split(', '));
      } else {
        geography = [];
      }

      setGeography(geography);

      let financial = profile.meta_data.find(item => item.param === 'financial');

      if (financial?.value) {
        financial = (Array.isArray(financial.value) ? financial.value : financial.value.split(', '));
      } else {
        financial = [];
      }

      setFinancial(financial);
    }
  }, [profile]);

  return (
    <>
      <Header activeElement="profile" handleFeedback={handleFeedback} handlePath={handlePath} handleStartOver={handleStartOver} />
      <div id="story" className="overflow">
        <div className="clamp">
          <div className="user">
            <div className="avatar">{userName?.substr(0, 1)}</div>
            <div className="user-info">
              <div className="user-name">{userName}</div>
              <div className="user-description">{userDescription}</div>
            </div>
          </div>
          {pills?.length ? (
            <div className="pills">
              {pills.map((pill, pillIndex) => 
                <div key={pillIndex} className="pill pill-light">{pill}</div>
              )}
            </div>
          ) : null}
          {profile?.narrative ? (
            <div className="callout">This is your story and it's a great one!</div>
          ) : null}
          <div className="story">
            <div className="story-body">
              <div className="story-title">Your Story</div>
              <div className="story-text">
                {profile?.narrative ? (
                  <>{profile.narrative}</>
                ) : (
                  <>We're still getting to know you. The more you explore, the more your story will grow.</>
                )}
              </div>
              {directions?.length ? (
                <>
                  <div className="story-title">Direction After High School</div>
                  <div className="pills">
                    {directions.map((pill, pillIndex) => 
                      <div key={pillIndex} className="pill pill-theme-2">{pill}</div>
                    )}
                  </div>
                </>
              ) : null}
              {future ? (
                <>
                  <div className="story-title">What You're Thinking About</div>
                  <div className="story-text story-text-quote">"{future}"</div>
                </>
              ) : null}
              {values ? (
                <>
                  <div className="story-title">What Matters Most to Me</div>
                  <div className="pills">
                    {values.map((pill, pillIndex) => 
                      <div key={pillIndex} className="pill pill-theme-2">{pill}</div>
                    )}
                  </div>
                </>
              ) : null}
              {strengths?.length ? (
                <>
                  <div className="story-title">What Comes Naturally to Me</div>
                  <div className="pills">
                    {strengths.map((pill, pillIndex) => 
                      <div key={pillIndex} className="pill pill-theme-2">{pill}</div>
                    )}
                  </div>
                </>
              ) : null}
              {geography ? (
                <>
                  <div className="story-title">How Far from Home</div>
                  <div className="pills">
                    {geography.map((pill, pillIndex) => 
                      <div key={pillIndex} className="pill pill-theme-2">{pill}</div>
                    )}
                  </div>
                </>
              ) : null}
              {financial ? (
                <>
                  <div className="story-title">Financial Aid</div>
                  <div className="pills">
                    {financial.map((pill, pillIndex) => 
                      <div key={pillIndex} className="pill pill-theme-2">{pill}</div>
                    )}
                  </div>
                </>
              ) : null}
            </div>
            <div className="story-footer">
              <div className="details-text">
                <p>This is based on what you've told us so far. Tap "Edit details" to update or add anything.</p>
                <p><strong>Graduating soon?</strong> Your school email will stop working in August — tap "Edit details" to add a personal email and/or phone number so you don’t lose access.</p>
              </div>
              <div className="action action-primary" onClick={handleDetails}>Edit details</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;
